import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/Dialog.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/dialog/react/latest'} mdxType="DeprecationBanner" />
    <p>{`The dialog component is used for all modals. It renders on top of the rest of the app with an overlay.`}</p>
    <p>{`You'll need to manage the `}<inlineCode parentName="p">{`isOpen`}</inlineCode>{` state in a wrapper component of your own and pass in a function to be used to close the Dialog. For documentation purposes only we've created a mock `}<inlineCode parentName="p">{`State`}</inlineCode>{` to handle this, but you should handle the state in the component you consume `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{` in or in a wrapper component.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`A few considerations must be made to ensure your use of the `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{` component is accessible:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Always be sure to provide either `}<inlineCode parentName="p">{`aria-labelledby`}</inlineCode>{` or `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` to your `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{` component. In most cases you should use `}<inlineCode parentName="p">{`aria-labelledby`}</inlineCode>{` and pass it the `}<inlineCode parentName="p">{`id`}</inlineCode>{` of your `}<inlineCode parentName="p">{`Dialog.Header`}</inlineCode>{`. If there is no text in your header, or you chose not to use a header, you can use `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` to describe the purpose of the `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Be sure to pass a ref to return the focus back to once the `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{` closes via the `}<inlineCode parentName="p">{`returnFocusRef`}</inlineCode>{` prop. In most cases this should be the element that opened the Dialog. If you decide to manage focus within your application and want to bypass Primer React Components from doing so when the `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{` closes, you can omit the `}<inlineCode parentName="p">{`returnFocusProp`}</inlineCode>{`.`}</p>
      </li>
    </ul>
    <h2>{`Z-index`}</h2>
    <p>{`If you're running into z-index issues or are rendering the component inside of an absolutely positioned element, you can wrap your `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{` in a `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/portals.html"
      }}>{`React Portal`}</a>{`.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State default={false}>
  {([isOpen, setIsOpen]) => {
    const returnFocusRef = React.useRef(null)
    return (
      <>
        <Button ref={returnFocusRef} onClick={() => setIsOpen(true)}>
          Open
        </Button>
        <Dialog
          returnFocusRef={returnFocusRef}
          isOpen={isOpen}
          onDismiss={() => setIsOpen(false)}
          aria-labelledby="header-id"
        >
          <Dialog.Header id="header-id">Title</Dialog.Header>
          <Box p={3}>
            <Text fontFamily="sans-serif">Some content</Text>
          </Box>
        </Dialog>
      </>
    )
  }}
</State>
`}</code></pre>
    <p>{`You can also pass any non-text content into the header:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<State default={false}>
  {([isOpen, setIsOpen]) => {
    const returnFocusRef = React.useRef(null)
    return (
      <>
        <Button ref={returnFocusRef} onClick={() => setIsOpen(true)}>
          Open
        </Button>
        <Dialog
          isOpen={isOpen}
          returnFocusRef={returnFocusRef}
          onDismiss={() => setIsOpen(false)}
          aria-labelledby="label"
        >
          <Dialog.Header>
            <ZapIcon />
          </Dialog.Header>
          <Box p={3}>
            <Text id="label" fontFamily="sans-serif">
              Are you sure you'd like to delete this issue?
            </Text>
            <Box display="flex" mt={3} justifyContent="flex-end">
              <Button sx={{mr: 1}}>Cancel</Button>
              <Button variant="danger">Delete</Button>
            </Box>
          </Box>
        </Dialog>
      </>
    )
  }}
</State>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      